{
  "accountInformationText": "在下方更新您的个人账户信息。",
  "accountSettings": "账户设置",
  "accountStatus": "账户状态",
  "accountStatusText": "您的账户当前状态良好。",
  "active": "已激活",
  "administrator": "管理员",
  "backupCodeFailed": "备用验证码验证失败。",
  "backupCodes": "备用验证码",
  "backupCodesWarning": "请妥善保存这些验证码，每个备用验证码仅可使用一次。",
  "changePassword": "修改密码",
  "confirmPassword": "确认密码",
  "copyBackupCodes": "复制备用验证码",
  "currentPassword": "当前密码",
  "darkMode": "深色模式",
  "depositWithdrawalAlerts": "充值与提现提醒",
  "disable2FA": "关闭双重身份验证",
  "disable2fa": "关闭 Google 身份验证器",
  "downloadBackupCodes": "下载备用验证码",
  "emailNotifications": "邮件通知",
  "enterAuthenticatorCode": "输入验证器应用中的6位验证码",
  "enterAuthenticatorCodeFirst": "请先输入验证器验证码。",
  "enterSixDigitCode": "输入6位验证码",
  "goToKycVerification": "前往 KYC 验证",
  "googleAuthenticator2fa": "Google 身份验证器 (2FA)",
  "googleAuthenticator2faText": "使用 Google 身份验证器为您的账户增加一层额外的安全保护。",
  "googleAuthenticatorDisabled": "Google 身份验证器已关闭。",
  "googleAuthenticatorEnabled": "Google 身份验证器已启用。",
  "inactive": "未激活",
  "invalidCode": "验证码无效，请重试。",
  "invalidVerificationCode": "验证码无效。",
  "kycStatusText": "完成身份验证以解锁完整账户功能。",
  "language": "语言",
  "languagePreferencesText": "选择您账户中使用的语言。",
  "languageSettings": "语言设置",
  "lightMode": "浅色模式",
  "loading": "加载中...",
  "loginAlerts": "登录提醒",
  "manualSetupKey": "手动设置密钥",
  "newBackupCodesGenerated": "新的备用验证码已生成，请妥善保存。",
  "newPassword": "新密码",
  "notificationPreferences": "通知偏好设置",
  "notificationPreferencesText": "选择您希望接收的提醒类型。",
  "notificationSettings": "通知设置",
  "owner": "所有者",
  "ownerControlCenter": "所有者控制中心",
  "ownerDisableBlocked": "所有者账户无法关闭 Google 身份验证器。",
  "p2pAlerts": "P2P 提醒",
  "p2pOrderAlerts": "P2P 订单提醒",
  "pushNotifications": "推送通知",
  "regenerateBackupCodes": "重新生成备用验证码",
  "require2FASetup": "继续操作前需要先设置 Google 身份验证器。",
  "role": "角色",
  "saveBackupCodes": "保存备用验证码",
  "saveChanges": "保存更改",
  "saving": "保存中...",
  "scanQrCode": "扫描此二维码",
  "scanQrCodeAuthenticator": "使用验证器应用扫描此二维码",
  "securityAlerts": "安全提醒",
  "securityRules": "安全规则",
  "securitySettings": "安全设置",
  "selectLanguage": "选择语言",
  "serverError": "服务器错误。",
  "sessionExpired": "会话已过期，请重新登录。",
  "settingRuleBotProtection": "此账户已启用自动机器人活动防护。",
  "settingRuleDepositReview": "大额充值将在计入余额前进行审核。",
  "settingRuleKyc": "提现批准前需完成身份验证。",
  "settingRuleManualReview": "可疑活动可能触发人工安全审核。",
  "settingRuleWalletMatch": "提现地址必须与已验证钱包地址一致。",
  "settingsSubtitle": "管理您的账户、语言、身份验证及安全设置。",
  "settingsTitle": "设置与安全",
  "settingsUpdateFailed": "设置更新失败。",
  "settingsUpdated": "设置更新成功。",
  "setup2FA": "设置 Google 身份验证器",
  "setupGoogleAuthenticator": "设置 Google 身份验证器",
  "systemDefault": "跟随系统",
  "theme": "主题",
  "twoFaSetupFailed": "双重身份验证设置失败。",
  "twoFactorAuthentication": "Google 身份验证器 (2FA)",
  "twoFactorDescription": "使用 Google 身份验证器保护您的账户。",
  "twoFactorDisabled": "双重身份验证已关闭",
  "twoFactorDisabledSuccess": "Google 身份验证器关闭成功。",
  "twoFactorEnabled": "双重身份验证已启用",
  "twoFactorSecurity": "双重身份安全",
  "twoFactorSecurityText": "启用双重身份验证以增强账户安全性。",
  "twoFactorSetupFailed": "双重身份验证设置失败。",
  "twoFactorVerified": "Google 身份验证器启用成功。",
  "user": "用户",
  "verificationCode": "验证码",
  "verify2FA": "验证并启用",
  "verifyAndEnable": "验证并启用"
}